import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const activationHighlightStyle = {
  color: '#842029',
  backgroundColor: '#f8d7da',
  fontWeight: 700,
  padding: '0.1rem 0.4rem',
  borderRadius: '0.35rem',
};

const getLoginErrorDetails = (message) => {
  const fallbackMessage = 'Benutzer unbekannt oder Passwort falsch';
  const normalizedMessage = (message || '').toLowerCase();
  const isActivationError =
    normalizedMessage.includes('bitte bestätigen sie zuerst ihre e-mail-adresse') ||
    (normalizedMessage.includes('e-mail') &&
      (normalizedMessage.includes('bestätigen') || normalizedMessage.includes('aktiv')));

  if (isActivationError) {
    return {
      type: 'activation',
      text: 'Ihr Konto ist noch nicht aktiviert. Bitte öffnen Sie zuerst den Bestätigungslink aus Ihrer Registrierungs-E-Mail. Prüfen Sie auch Ihren Spam-Ordner. Erst danach ist ein Login möglich.',
    };
  }

  return {
    type: 'default',
    text: normalizedMessage.includes('benutzer unbekannt oder passwort falsch')
      ? 'Benutzer unbekannt oder Passwort falsch'
      : fallbackMessage,
  };
};

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const result = await login(username, password);
    if (result.success) {
      navigate('/');
    } else {
      setError(getLoginErrorDetails(result.error));
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h2 className="text-center mb-4">Login</h2>
              {error && (
                <div
                  className={`alert ${error.type === 'activation' ? 'alert-warning login-feedback login-feedback-warning' : 'alert-danger login-feedback login-feedback-error'}`}
                  role="alert"
                  aria-live="assertive"
                >
                  {error.type === 'activation' && (
                    <div className="fw-bold mb-2" style={{ color: '#842029' }}>
                      E-Mail-Adresse noch nicht bestätigt
                    </div>
                  )}
                  {error.type === 'activation' ? (
                    <div style={{ color: '#664d03' }}>
                      <div className="mb-2">
                        <span style={activationHighlightStyle}>Ihr Konto ist noch nicht aktiviert.</span>
                      </div>
                      <div>
                        Bitte öffnen Sie den{' '}
                        <span style={activationHighlightStyle}>Bestätigungslink</span>{' '}
                        aus Ihrer Registrierungs-E-Mail. Prüfen Sie auch Ihren{' '}
                        <span style={activationHighlightStyle}>Spam-Ordner</span>. Erst danach ist ein{' '}
                        <span style={activationHighlightStyle}>Login möglich</span>.
                      </div>
                    </div>
                  ) : (
                    <div className="login-feedback-content">
                      <div className="login-feedback-title">
                        <span className="login-feedback-icon" aria-hidden="true">⚠</span>
                        <span>Anmeldung fehlgeschlagen</span>
                      </div>
                      <div className="login-feedback-text">{error.text}</div>
                    </div>
                  )}
                </div>
              )}
              <div className="alert alert-info" style={{ fontSize: '0.95em' }}>
                Nach der Registrierung müssen Sie zuerst den
                Bestätigungslink in Ihrer E-Mail
                öffnen, bevor Sie sich anmelden können.
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>E-Mail oder Username</label>
                  <input
                    type="text"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="max@example.com"
                    required
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Passwort</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100 mt-3">
                  Login
                </button>
              </form>
              <div className="text-center mt-3">
                <small>
                  Noch kein Account?{' '}
                  <a href="/register" style={{ color: '#1976d2', textDecoration: 'none' }}>
                    Jetzt registrieren
                  </a>
                </small>
              </div>
              <div className="text-center mt-2">
                <small>
                  <a href="/forgot-password" style={{ color: '#888', textDecoration: 'none' }}>
                    Passwort vergessen?
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
